var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_138",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    "data-name": "Group 6356",
    transform: "translate(4.5 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#Ellipse_138)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138-2",
    "data-name": "Ellipse 138",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(4.5 3.5)",
    fill: "#e10092"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-right",
    "data-name": "Icon awesome-chevron-right",
    d: "M7.514,7.738l-4.2,4.2a.519.519,0,0,1-.734,0l-.49-.49a.519.519,0,0,1,0-.733L5.416,7.371,2.084,4.024a.519.519,0,0,1,0-.733l.49-.49a.519.519,0,0,1,.734,0L7.514,7A.519.519,0,0,1,7.514,7.738Z",
    transform: "translate(5.567 2.353)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.67c3f0948e7ce8ae6cfc11f0f8e61c10.svg";
export { ForwardRef as ReactComponent };